<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <header id="headerKo" :class="['header', cssname]">
    <h1 class="logo_minisoft">
      <a href="/">
        <svg
          width="171"
          height="60"
          viewBox="0 0 171 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M97.8659 10.6258C98.3005 8.45344 99.8045 7.39108 102.441 7.38632C104.287 7.38632 105.781 7.97228 106.68 8.51537L106.865 8.62495L109.033 5.05198L108.877 4.95194C107.652 4.09919 105.537 3.45606 102.534 3.45606C96.9577 3.4513 92.7778 6.99567 91.9819 11.1784C91.9233 11.4357 91.8891 11.7072 91.8647 11.974C91.6742 14.3274 92.7925 16.8237 96.8844 18.4053C99.7215 19.5058 100.723 20.5348 100.61 22.0879C100.605 22.226 100.581 22.3689 100.552 22.5166C100.107 24.7938 98.2908 26.0181 95.4293 26.0277C93.227 26.0277 91.6938 25.4417 90.8099 24.8653L90.6195 24.7462L88.2756 28.6955L88.4368 28.8003C89.9066 29.7197 92.0453 30.2819 95.6002 30.2819H95.61C101.211 30.2819 105.918 26.9328 106.812 22.2641C106.87 21.9354 106.919 21.6115 106.944 21.2732C107.134 18.9865 106.196 16.4759 101.426 14.6228C99.1599 13.7367 97.6609 12.8172 97.8073 11.0212C97.8171 10.8926 97.8415 10.764 97.8659 10.6258Z"
            fill="white"
          />
          <path
            d="M130.612 17.8622C130.998 12.7219 128.488 9.02028 122.506 9.01076C115.875 9.00123 111.763 13.5746 110.625 19.6439C110.503 20.2442 110.43 20.8396 110.381 21.4161C109.996 26.523 112.535 30.277 118.497 30.2818H118.516C125.133 30.2818 129.24 25.6798 130.368 19.6915C130.48 19.0627 130.563 18.4529 130.612 17.8622ZM125.069 17.4239C125.011 18.1147 124.889 18.8578 124.733 19.601C123.995 23.0263 122.677 26.0514 119.122 26.0323C116.378 26.0276 115.767 24.1696 115.963 21.6162C116.021 20.9873 116.129 20.3204 116.27 19.6439C117.017 16.19 118.414 13.0268 121.93 13.0411C124.698 13.0506 125.26 14.8942 125.069 17.4239Z"
            fill="white"
          />
          <path
            d="M163.938 13.5034H169.393L170.179 9.38738H164.73L165.74 4.22803H161.36C160.594 4.22803 159.959 4.75683 159.803 5.46189L159.046 9.39215H155.52C154.807 9.39215 154.202 9.84949 154.001 10.4831L153.42 13.5082H158.255C158.255 13.5082 156.057 25.0989 156.038 25.3085C155.847 27.9287 157.41 30.2582 161.683 30.2582C162.957 30.2582 163.968 30.0296 164.51 29.839L165.14 29.6151L165.848 25.9135L165.037 26.166C164.583 26.2804 164.251 26.3423 163.802 26.3423C162.268 26.3137 161.824 25.6467 161.878 24.4462C161.892 24.2938 163.938 13.5034 163.938 13.5034Z"
            fill="white"
          />
          <path
            d="M40.085 30.0008H44.4211H44.4358C45.2415 30.0008 45.9153 29.4434 46.0813 28.705L49.729 9.38721H43.9816L40.085 30.0008Z"
            fill="white"
          />
          <path
            d="M29.0736 9.00146C25.2649 9.00146 22.628 10.0591 20.8262 11.3977C19.249 9.86374 16.91 9.00146 14.4343 9.00146C5.16138 9.00146 2.8224 15.2708 2.60266 16.5666L0 30.001H4.33614H4.35079C5.16138 30.001 5.845 29.4388 6.00126 28.6861L7.61267 20.2253C8.25723 17.0049 9.6196 13.3557 13.609 13.3557C15.4548 13.3557 16.7733 14.5705 16.8221 16.3713C16.866 17.9625 16.5633 19.4298 16.2996 20.8923L14.6394 29.9962H18.9755H18.9902C19.8056 29.9962 20.4941 29.4245 20.6455 28.6623L20.6504 28.6671C20.6504 28.6671 22.4229 19.5774 22.5255 19.0201C23.2726 16.1569 24.7473 13.351 28.2484 13.351C30.0942 13.351 31.4175 14.5658 31.4615 16.3665C31.5103 17.9577 31.2027 19.425 30.9439 20.8875L29.2836 29.9914H33.6246H33.6393C34.4548 29.9914 35.1433 29.4198 35.2946 28.6623L36.8621 20.5922C37.1258 19.2535 37.5115 17.5385 37.4676 15.9044C37.3504 11.6455 33.4098 9.00146 29.0736 9.00146Z"
            fill="white"
          />
          <path
            d="M76.6833 30.0008H81.0244H81.039C81.8447 30.0008 82.5186 29.4434 82.6846 28.705L86.3371 9.38721H80.58L76.6833 30.0008Z"
            fill="white"
          />
          <path
            d="M65.6721 9.00146C56.3992 9.00146 54.0651 15.2708 53.8405 16.5666L51.2378 30.001H55.5739H55.5886C56.3992 30.001 57.0828 29.4388 57.2391 28.6909L58.8505 20.2253C59.495 17.0049 60.8574 13.3557 64.8468 13.3557C66.6926 13.3557 68.011 14.5705 68.0648 16.3713C68.1087 17.9625 67.806 19.4298 67.5423 20.8923L65.882 29.9962H70.2182H70.2377C71.0532 29.9962 71.7417 29.4245 71.8931 28.6671L73.4605 20.5969C73.7242 19.2583 74.11 17.5432 74.066 15.9092C73.9439 11.6455 70.0082 9.00146 65.6721 9.00146Z"
            fill="white"
          />
          <path
            d="M140.314 7.14825L139.889 9.38731H134.728L133.942 13.5034H139.103L130.26 59.9995H135.939L144.797 13.5034H149.045H149.06C149.797 13.5034 150.398 12.9936 150.534 12.3219L151.106 9.38731H145.583L146.022 7.07679C146.457 4.92349 148.044 4.45662 150.842 4.45662C151.443 4.45662 151.931 3.90876 152.048 3.29898H152.053L152.6 0.39297C152.6 0.39297 151.155 0.173828 149.856 0.173828C144.758 0.173828 141.13 2.81306 140.314 7.14825Z"
            fill="white"
          />
        </svg>
        <span class="blind">{{ $t("FOOTER.0001") }}</span>
      </a>
    </h1>

    <!-- main menu area -->
    <MainMenu></MainMenu>

    <div class="lang-container">
      <div class="lang-active" @click="eventHandler.toggleList">
        <p id="activKr" class="kr" v-show="$i18n.locale == 'ko'">
          <span class="ico_lang">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_974_130)">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0.048 7.152C0.12 6.504 0.264 5.872 0.48 5.28C1.584 2.2 4.536 0 8 0C12.416 0 16 3.584 16 8C16 8.968 15.824 9.904 15.512 10.76C15.48 10.84 15.448 10.92 15.416 11C14.232 13.928 11.352 15.992 8 15.992C3.584 16 0 12.416 0 8C0 7.712 0.016 7.432 0.048 7.152ZM8 1.12C11.704 1.12 14.728 4.048 14.872 7.72C14.864 7.696 14.848 7.68 14.832 7.656C14.176 6.568 13.04 5.688 11.408 5.688C9.28 5.688 8.272 6.92 7.416 7.968L7.376 8.016C6.936 8.552 6.544 9.024 6.048 9.368C5.576 9.696 4.992 9.928 4.152 9.928C2.96 9.928 2.152 9.408 1.672 8.616C1.416 8.2 1.248 7.704 1.168 7.144C1.592 3.752 4.488 1.12 8 1.12Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_974_130">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </span>
          <span class="txt_lang">KO</span>
        </p>
        <p id="activEn" class="en" v-show="$i18n.locale == 'en'">
          <span class="ico_lang">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_974_136)">
                <path
                  d="M0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8ZM7.5 1.077C6.83 1.281 6.165 1.897 5.613 2.932C5.47 3.2 5.337 3.492 5.218 3.804C5.923 3.961 6.69 4.061 7.5 4.091V1.077ZM4.249 3.539C4.391 3.155 4.553 2.795 4.73 2.461C4.90291 2.13406 5.10259 1.82199 5.327 1.528C4.47567 1.8808 3.70225 2.398 3.051 3.05C3.413 3.234 3.814 3.398 4.249 3.539ZM3.509 7.5C3.545 6.43 3.697 5.413 3.945 4.492C3.4037 4.31889 2.87976 4.09559 2.38 3.825C1.58354 4.89435 1.11082 6.16987 1.018 7.5H3.508H3.509ZM4.909 4.759C4.67325 5.65477 4.53907 6.57422 4.509 7.5H7.5V5.091C6.59 5.061 5.717 4.946 4.909 4.759ZM8.5 5.09V7.5H11.49C11.4603 6.57426 11.3264 5.6548 11.091 4.759C10.283 4.946 9.41 5.059 8.5 5.09ZM4.51 8.5C4.545 9.487 4.686 10.414 4.909 11.241C5.76006 11.0479 6.62772 10.937 7.5 10.91V8.5H4.51ZM8.5 8.5V10.909C9.41 10.939 10.283 11.054 11.091 11.241C11.314 10.414 11.455 9.487 11.491 8.5H8.5ZM5.218 12.196C5.338 12.508 5.47 12.8 5.613 13.068C6.165 14.103 6.831 14.718 7.5 14.923V11.91C6.69 11.94 5.923 12.039 5.218 12.196ZM5.328 14.472C5.10323 14.1781 4.90321 13.866 4.73 13.539C4.54582 13.1904 4.38513 12.83 4.249 12.46C3.83763 12.5922 3.4371 12.756 3.051 12.95C3.70225 13.602 4.47667 14.1192 5.328 14.472ZM3.945 11.508C3.68538 10.5252 3.53876 9.51603 3.508 8.5H1.018C1.11077 9.83014 1.5835 11.1057 2.38 12.175C2.85 11.917 3.375 11.693 3.945 11.508ZM10.673 14.472C11.5239 14.1194 12.297 13.6026 12.948 12.951C12.5622 12.7571 12.162 12.5932 11.751 12.461C11.6148 12.8306 11.4541 13.1908 11.27 13.539C11.0971 13.866 10.8975 14.178 10.673 14.472ZM8.5 11.909V14.923C9.17 14.719 9.835 14.103 10.387 13.068C10.53 12.8 10.663 12.508 10.782 12.196C10.0316 12.0315 9.26778 11.9347 8.5 11.909ZM12.055 11.508C12.625 11.693 13.15 11.917 13.62 12.175C14.4165 11.1057 14.8892 9.83014 14.982 8.5H12.492C12.4612 9.51603 12.3146 10.5252 12.055 11.508ZM14.982 7.5C14.8892 6.16986 14.4165 4.89433 13.62 3.825C13.15 4.083 12.625 4.307 12.055 4.492C12.303 5.412 12.455 6.43 12.492 7.5H14.982ZM11.27 2.461C11.447 2.795 11.609 3.155 11.752 3.539C12.1627 3.40675 12.5626 3.24292 12.948 3.049C12.2969 2.39782 11.5238 1.88132 10.673 1.529C10.891 1.812 11.091 2.126 11.27 2.461ZM10.782 3.804C10.6684 3.50549 10.5365 3.21427 10.387 2.932C9.835 1.897 9.17 1.282 8.5 1.077V4.09C9.31 4.06 10.077 3.961 10.782 3.804Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_974_136">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </span>
          <span class="txt_lang">EN</span>
        </p>
        <p id="activJp" class="jp" v-show="$i18n.locale == 'jp'">
          <span class="ico_lang">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_974_123)">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM12 8C12 10.2091 10.2091 12 8 12C5.79086 12 4 10.2091 4 8C4 5.79086 5.79086 4 8 4C10.2091 4 12 5.79086 12 8Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_974_123">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </span>
          <span class="txt_lang">JP</span>
        </p>
      </div>
      <ul class="lang-btn" v-show="state.isListOpen" style="right: 0">
        <li
          :class="['lang-item', 'lang-item-' + locale]"
          v-for="(locale, index) in $i18n.availableLocales"
          :key="index"
        >
          <a @click="eventHandler.changeLanguage($i18n, locale)">
            <span>{{ locale.toUpperCase() }}</span>
          </a>
        </li>
      </ul>
    </div>
    <!-- mobile -->
    <div class="small_nav-btn">
      <div class="open" @click="eventHandler.showMNavi" v-if="!state.isMMenu">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="close" @click="eventHandler.closeMNavi" v-if="state.isMMenu">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-x-lg"
          viewBox="0 0 16 16"
        >
          <path
            d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"
            stroke="#fff"
          />
        </svg>
      </div>
    </div>
    <!-- S: mobile navigation -->
    <transition name="slide-fade">
      <nav class="small_nav-container" v-if="state.isMMenu">
        <h1 class="logo_minisoft_nav"></h1>
        <ul class="sm_menu">
          <li class="sm_menu-item">
            <RouterLink :to="{path:'about'}" class="main_tt" @click.native="eventHandler.closeMNavi">
              <span>{{ $t("HEADER.0001") }}</span>
            </RouterLink>
            <ul class="sm_sub_menu">
              <li class="sm_item">
                <RouterLink :to="{path:'about', hash:'#aboutMiniOutline'}" @click.native="eventHandler.closeMNavi">
                  <span class="sub_tt">{{ $t("HEADER.0001") }}</span>
                </RouterLink>
              </li>
              <li class="sm_item">
                <RouterLink :to="{path:'about', hash:'#aboutMiniPhilosopy'}" @click.native="eventHandler.closeMNavi">
                  <span class="sub_tt">{{ $t("HEADER.0008") }}</span>
                </RouterLink>
              </li>
              <li class="sm_item">
                <RouterLink :to="{path:'about', hash:'#aboutMiniHistory'}" @click.native="eventHandler.closeMNavi">
                  <span class="sub_tt">{{ $t("HEADER.0009") }}</span>
                </RouterLink>
              </li>
            </ul>
          </li>
          <li class="sm_menu-item">
            <RouterLink :to="{path:'/business'}" class="main_tt" @click.native="eventHandler.closeMNavi">
              <span>{{ $t("HEADER.0002") }}</span>
            </RouterLink>
            <ul class="sm_sub_menu">
              <!-- 2025/08/04 추가 -->
              <li class="sm_item">
                <RouterLink :to="{path:'/business', hash:'#mBusiAx'}" @click.native="eventHandler.closeMNavi">
                  <span class="sub_tt">AI Transformation</span>
                </RouterLink>
              </li>
              <li class="sm_item">
                <RouterLink :to="{path:'/business', hash:'#mBusiSi'}" @click.native="eventHandler.closeMNavi">
                  <span class="sub_tt">{{ $t("HEADER.0010") }}</span>
                </RouterLink>
              </li>
              <li class="sm_item">
                <RouterLink :to="{path:'/business', hash:'#mBusiIot'}" @click.native="eventHandler.closeMNavi">
                  <span class="sub_tt">{{ $t("HEADER.0011") }}</span>
                </RouterLink>
              </li>
              <li class="sm_item">
                <RouterLink :to="{path:'/business', hash:'#mBusiSmk'}" @click.native="eventHandler.closeMNavi">
                  <span class="sub_tt">{{ $t("HEADER.0012") }}</span>
                </RouterLink>
              </li>
            </ul>
          </li>
          <li class="sm_menu-item">
            <RouterLink :to="{path:'/solution'}" class="main_tt" @click.native="eventHandler.closeMNavi">
              <span>{{ $t("HEADER.0003") }}</span>
            </RouterLink>
            <ul class="sm_sub_menu">
              <!-- 2025/08/04 추가 -->
              <li class="sm_item">
                <RouterLink :to="{path:'/solution', hash:'#luminus'}" @click.native="eventHandler.closeMNavi">
                  <span class="sub_tt">LUMINUS</span>
                </RouterLink>
              </li>
              <li class="sm_item">
                <RouterLink :to="{path:'/solution', hash:'#sela'}" @click.native="eventHandler.closeMNavi">
                  <span class="sub_tt">SELA</span>
                </RouterLink>
              </li>
              <li class="sm_item">
                <RouterLink :to="{path:'/solution', hash:'#she'}" @click.native="eventHandler.closeMNavi">
                  <span class="sub_tt">Smart On-site</span>
                </RouterLink>
              </li>
              <li class="sm_item">
                <RouterLink :to="{path:'/solution', hash:'#soliDocs'}" @click.native="eventHandler.closeMNavi">
                  <span class="sub_tt">{{ $t("HEADER.0013") }}</span>
                </RouterLink>
              </li>
              <!-- <li class="sm_item">
                <RouterLink :to="{path:'/solution', hash:'#soliWorks'}" @click.native="eventHandler.closeMNavi">
                  <span class="sub_tt">{{ $t("HEADER.0014") }}</span>
                </RouterLink>
              </li>
              <li class="sm_item">
                <RouterLink :to="{path:'/solution', hash:'#onClass'}" @click.native="eventHandler.closeMNavi">
                  <span class="sub_tt">{{ $t("HEADER.0015") }}</span>
                </RouterLink>
              </li> -->
            </ul>
          </li>
          <li class="sm_menu-item">
            <RouterLink :to="{path:'/recruit'}" class="main_tt" @click.native="eventHandler.closeMNavi">
              <span>{{ $t("HEADER.0004") }}</span>
            </RouterLink>
            <ul class="sm_sub_menu">
              <li class="sm_item">
                <RouterLink :to="{path:'/recruit', hash:'#rcWelfare'}" @click.native="eventHandler.closeMNavi">
                  <span class="sub_tt">{{ $t("HEADER.0016") }}</span>
                </RouterLink>
              </li>
              <li class="sm_item">
                <RouterLink :to="{path:'/recruit', hash:'#rcRecruit'}" @click.native="eventHandler.closeMNavi">
                  <span class="sub_tt">{{ $t("HEADER.0017") }}</span>
                </RouterLink>
              </li>
            </ul>
          </li>
          <li class="sm_menu-item">
            <RouterLink :to="{path:'/customer'}" class="main_tt" @click.native="eventHandler.closeMNavi">
              <span>{{ $t("HEADER.0005") }}</span>
            </RouterLink>
            <ul class="sm_sub_menu">
              <li class="sm_item">
                <RouterLink :to="{path:'/customer', hash:'#csApply'}" @click.native="eventHandler.closeMNavi">
                  <span class="sub_tt">{{ $t("HEADER.0018") }}</span>
                </RouterLink>
              </li>
            </ul>
          </li>
          <li class="sm_menu-item">
            <RouterLink :to="{path:'/esg'}" class="main_tt" @click.native="eventHandler.closeMNavi">
              <span>{{ $t("HEADER.0006") }}</span>
            </RouterLink>
            <ul class="sm_sub_menu">
              <li class="sm_item">
                <RouterLink :to="{path:'/esg', hash:'#esgEsg'}" @click.native="eventHandler.closeMNavi">
                  <span class="sub_tt">{{ $t("HEADER.0019") }}</span>
                </RouterLink>
              </li>
              <li class="sm_item">
                <RouterLink :to="{path:'/esg', hash:'#esgLaw'}" @click.native="eventHandler.closeMNavi">
                  <span class="sub_tt">{{ $t("HEADER.0020") }}</span>
                </RouterLink>
              </li>
              <li class="sm_item">
                <RouterLink :to="{path:'/esg', hash:'#esgHuman'}" @click.native="eventHandler.closeMNavi">
                  <span class="sub_tt">{{ $t("HEADER.0021") }}</span>
                </RouterLink>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </transition>
    <!-- E: mobile navigation -->
  </header>
</template>

<script>
import MainMenu from "@/components/mainmenu";
import { reactive } from "@vue/reactivity";
import { onMounted } from "@vue/runtime-core";
import { useRouter } from "vue-router";

export default {
  props: {
    cssname: {
      type: String,
      required: true,
      default: "",
    },
  },
  components: {
    MainMenu
},
  setup() {
    const state = reactive({
      scrollHeight: 0,
      isMMenu: false,
      isListOpen: false,
      currentlang: "en",
    });
    const router = useRouter();

    const eventHandler = {
      showMNavi(e) {
        state.isMMenu = true;
        document.body.style.overflow = "hidden";
      },
      closeMNavi(e) {
        state.isMMenu = false;
        document.body.style.overflow = "visible";
      },
      changeLanguage(i18n, selectlocale) {
        i18n.locale = selectlocale;
        localStorage.setItem("language", selectlocale);
        state.isListOpen = false;
        document.body.classList.remove(state.currentlang);
        state.currentlang = selectlocale;
        document.body.classList.add(state.currentlang);
      },
      toggleList() {
        state.isListOpen = !state.isListOpen;
      },
    };

    onMounted(() => {
      state.currentlang = localStorage.getItem("language") || "ko";
      document.body.classList.add(state.currentlang);

      var elHeader = document.querySelector(".header");
      state.scrollHeight = elHeader.clientHeight;

      const btnMainNavs = document.querySelectorAll(
        ".header .main_nav .menu-item a"
      );
      
      window.addEventListener("scroll", function () {
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > state.scrollHeight) {
          document.querySelector(".header").classList.add("header_scroll");
        } else {
          document.querySelector(".header").classList.remove("header_scroll");
        }
      });

      btnMainNavs.forEach((btn) => {
        btn.addEventListener("mouseenter", function (e) {
          e.target.classList.add("main_nav_active");
        });
        btn.addEventListener("mouseleave", function (e) {
          e.target.classList.remove("main_nav_active");
        });
      });
    });

    return { state, eventHandler };
  },
};
</script>

<style>
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
